<template>
  <div v-if="work" v-show="$store.getters.isShowModal" class="p-works">
    <div class="p-works__close" @click="close">
      <span></span>
      <span></span>
    </div>

    <div
      ref="p-works__wrap"
      class="p-works__wrap p-works__wrap--center"
      :class="{'p-works__wrap--gallery': work.type === 'gallery'}"
    >
      <div ref="p-works__wrapInner">
        <div ref="wrap-head" class="p-works__wrapHead" :style="setStyleWidth()">
          <ul>
            <li>{{work.client}}</li>
            <li>{{work.title}}</li>
          </ul>
        </div>

        <div
          v-if="work.type === 'video' || work.type === 'video2'"
          ref="wrap-video"
          class="p-works__wrapVideo"
          :style="setStyleWrap()"
        >
          <div class="c-player">
            <div id="c-player__iframe" class="c-player__iframe"></div>
            <transition name="fade">
              <div
                v-show="!isPlayed"
                class="c-player__cover"
                :style="`background-image: url(${work.gallery[0]});`"
                @click="firstVideo"
              >
                <div class="c-btnPlay">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 54" width="40" height="54">
                    <path fill-rule="evenodd"  fill="rgb(0, 0, 0)" d="M29.806,50.574 C29.85,52.719 28.381,53.247 26.140,53.247 L26.140,51.422 C27.244,51.422 27.677,51.246 28.13,50.318 L25.20,42.202 L27.164,42.202 L28.941,47.325 L30.542,42.202 L32.607,42.202 L29.806,50.574 ZM20.942,49.501 C20.621,50.46 20.141,50.350 19.213,50.350 C17.548,50.350 16.396,49.469 16.396,47.837 C16.396,46.140 17.676,45.404 19.357,45.404 L20.942,45.404 L20.942,44.940 C20.942,44.43 20.669,43.755 19.517,43.755 C18.733,43.755 18.349,43.867 18.12,44.395 L16.572,43.387 C17.164,42.411 18.60,42.58 19.709,42.58 C21.774,42.58 22.942,42.667 22.942,44.956 L22.942,50.206 L20.942,50.206 L20.942,49.501 ZM20.942,46.908 L19.597,46.908 C18.765,46.908 18.397,47.180 18.397,47.805 C18.397,48.413 18.861,48.701 19.565,48.701 C20.493,48.701 20.942,48.301 20.942,47.212 L20.942,46.908 ZM10.836,47.645 L10.836,39.161 L12.885,39.161 L12.885,47.180 C12.885,48.45 13.141,48.445 14.5,48.445 L14.5,50.206 C11.844,50.206 10.836,49.645 10.836,47.645 ZM5.685,50.350 C4.853,50.350 4.293,50.190 3.925,49.886 L3.925,53.247 L1.876,53.247 L1.876,42.202 L3.925,42.202 L3.925,42.731 C4.309,42.298 4.885,42.58 5.701,42.58 C7.558,42.58 8.807,43.355 8.807,45.644 L8.807,46.732 C8.807,48.813 7.750,50.350 5.685,50.350 ZM6.758,45.772 C6.758,44.491 6.358,43.787 5.349,43.787 C4.373,43.787 3.925,44.427 3.925,45.596 L3.925,46.604 C3.925,47.757 4.197,48.621 5.349,48.621 C6.454,48.621 6.758,47.757 6.758,46.604 L6.758,45.772 Z"/>
                    <path fill-rule="evenodd"  fill="rgb(0, 0, 0)" d="M0.749,0.388 L39.110,15.249 L0.749,30.111 "/>
                  </svg>
                </div>
              </div>
            </transition>
          </div>
        </div>

        <div
          v-if="work.type === 'gallery'"
          ref="wrap-gallery"
          class="p-works__wrapGallery is-current1"
          @mousedown="swipeMouse"
          @mouseup="swipeMouse"
          @mousemove="swipeMouse"
          @touchstart="swipe"
          @touchmove="swipe"
          @touchend="swipe"
          @touchcancel="swipe"
        >
          <div :style="setStyleWrap()"></div>
          <ul ref="wrap-gallery-ul" :style="setStyleUL()">
            <li ref="wrap-gallery-img" v-for="(src, i) in work.gallery" :style="setStyleList(i)">
              <div :style="`background-image: url(${src});`"></div>
            </li>
          </ul>

          <ul v-if="max > 1" ref="wrap-gallery-ul_a" :style="setStyleUL_a()">
            <li ref="wrap-gallery-img" v-for="(src, i) in work.gallery" :style="setStyleList(i)">
              <div :style="`background-image: url(${src});`"></div>
            </li>
          </ul>

          <ul v-if="max > 1" ref="wrap-gallery-ul_b" :style="setStyleUL_b()">
            <li ref="wrap-gallery-img" v-for="(src, i) in work.gallery" :style="setStyleList(i)">
              <div :style="`background-image: url(${src});`"></div>
            </li>
          </ul>

          <div v-if="max > 1" class="c-arrowG c-arrowG--left c-arrowG--pc" @click="moveSlide('left')">
            <div class="c-arrowG__wrap">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 146.03 7.39" width="146.03" height="7.39">
                <path d="M10,3H146V4H10Z"/>
                <path d="M13.53,7.39,0,3.54,13.53,0"/>
              </svg>
            </div>
          </div>

          <div v-if="max > 1" class="c-arrowG c-arrowG--right c-arrowG--pc" @click="moveSlide('right')">
            <div class="c-arrowG__wrap">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 146.35 7.39" width="146.35" height="7.39">
                <path class="a" d="M0,3H136V4H0Z"/>
                <path class="a" d="M132.5,7.39l13.85-3.85L132.5,0"/>
              </svg>
            </div>
          </div>
        </div>

        <div ref="wrap-foot" class="p-works__wrapFoot" :style="setStyleWidth()">
          <ul v-if="work.type == 'gallery' && max > 1">
            <li>{{counter+1}}</li>
            <li>{{max}}</li>
          </ul>
          <small v-html="work.copyright"></small>
        </div>
      </div>

      <ul v-if="work.type == 'gallery' && max > 1 && !$store.getters.isPc" class="p-works__wrapSp" :style="setSpUI()">
        <li>
          <div class="c-arrowG c-arrowG--left c-arrowG--sp" @click="moveSlide('left')">
            <div class="c-arrowG__wrap">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 133 15" width="133" height="15">
                <path d="M20.999,6.499 L132.999,6.499 L132.999,8.499 L20.999,8.499 L20.999,6.499 Z"/>
                <path d="M28.15,14.570 L0.944,7.499 L28.15,0.428 "/>
              </svg>
            </div>
          </div>
        </li>
        <li>
          <ul class="sp-counter">
            <li>{{counter+1}}</li>
            <li>{{max}}</li>
          </ul>
        </li>
        <li>
          <div class="c-arrowG c-arrowG--right c-arrowG--sp" @click="moveSlide('right')">
            <div class="c-arrowG__wrap">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 134 15" width="134" height="15">
                <path d="M0.968,6.499 L112.968,6.499 L112.968,8.499 L0.968,8.499 L0.968,6.499 Z"/>
                <path d="M105.984,14.570 L133.55,7.499 L105.984,0.428 "/>
              </svg>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import {breakpoint, assets_path} from '@/_constant/variables';
  import store from '@/_modules/stores';
  import ResizeObserver from 'resize-observer-polyfill';
  import PerfectScrollbar from 'perfect-scrollbar';
  import {gsap, Cubic} from 'gsap';
  import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
  gsap.registerPlugin(ScrollToPlugin);

  export default {
    components: {
    },
    data() {
      return {
        breakpoint: breakpoint,
        assets_path: assets_path,
        setting: {
          margin: {
            pc: 120,
            sp: 0
          }
        },
        iframeID: 'c-player__iframe',
        styleWrap: '',
        styleUL: '',
        styleUL_a: '',
        styleUL_b: '',
        styleList: [],
        styleWidth: '',
        styleSpUI: '',
        isPlayed: false,
        isCenter: false,
        isSliding: false,
        id: null,
        work: null,
        max: 0,
        params: null,
        counter: 0,
        to: null,
        from: null,
        player: null,
        touchStartX: 0,
        touchMoveX: 0,
        moveW: 0,
        startTime: null,
        elSlider: null,
        ps: null,
        ro: null,
        roBody: null,
      }
    },
    store,
    beforeRouteEnter (to, from, next) {
      next(vm => {
        vm.params = to.params;
        vm.to = to;
        vm.from = from;
      });
    },
    beforeRouteUpdate(to, from, next) {
      // 削除
      this.destroy();
      // 次へ
      this.params = to.params;
      this.to = to;
      this.from = from;
      this.$nextTick(this.init);
      next();
    },
    beforeRouteLeave (to, from, next) {
      this.destroy();
      next();
    },
    computed: {
      setStyleWrap: function() {
        return function () {
          return this.styleWrap;
        }
      },
      setStyleList: function() {
        return function (i) {
          return this.styleList[i];
        }
      },
      setStyleUL: function() {
        return function () {
          return this.styleUL;
        }
      },
      setStyleUL_a: function() {
        return function () {
          return this.styleUL_a;
        }
      },
      setStyleUL_b: function() {
        return function () {
          return this.styleUL_b;
        }
      },
      setStyleWidth: function() {
        return function () {
          return this.styleWidth;
        }
      },
      setSpUI: function() {
        return function () {
          return this.styleSpUI;
        }
      },
    },
    mounted() {
      this.$nextTick(this.init);
    },
    destroyed() {

    },
    methods: {
      init() {
        if (this.params.data === undefined) {
          // idから引く
          const target = this.$siteData.works.find((work) => {
            return (work.id === parseInt(this.params.id, 10));
          });
          this.work = target;
        } else {
          this.work = this.params.data;
        }
        this.id = this.params.id;
        this.max = this.work.gallery.length;

        const title = this.work.title + '|' + this.to.meta.title;
        this.createPageTitle(title, this.to.meta.desc);

        this.$nextTick(this.open);
      },
      createPageTitle(title, desc) {
        document.title = title;
        document.querySelector("meta[name='description']").setAttribute('content', desc);
      },
      open() {
        this.$store.commit('setShowModal', true);

        // リサイズ
        this.resize();
        this.resizeBody();

        this.ro = new ResizeObserver(this.resizeCallback);
        this.ro.observe(this.$refs['p-works__wrap']);
        this.ro.observe(this.$refs['wrap-head']);

        this.roBody = new ResizeObserver(this.resizeBody);
        this.roBody.observe(document.body);
        window.addEventListener('resize', this.resizeBody);

        document.addEventListener('keydown', this.onKeydown);

        if (this.work.type === 'video' || this.work.type === 'video2') {

          if (this.work.type === 'video2') {
            // 動画の比率
            //const per = (this.work.video.height / this.work.video.width) * 100;
            const per = (9 / 16) * 100;
            this.styleWrap = `padding-top: ${per}%;`;
          }

          this.isReadyYT();
        } else {
          this.initScrollbar();
        }
      },
      onKeydown(e) {
        if (e.key === 'Escape') {
          this.close();
        }
      },
      initScrollbar() {
        // perfect scrollbar
        const baseScrollConfig = {
          wheelSpeed: 1,
          wheelPropagation: true,
          minScrollbarLength: 10,
          suppressScrollX: true
        };

        this.ps = new PerfectScrollbar(
          this.$el,
          baseScrollConfig
        );
        this.$el.scrollTop = 0;
      },
      isReadyYT() {
        if (window.gSLANTED.isReadyYT) {
          this.$nextTick(this.createVideo);
        } else {
          this.timer = setTimeout(this.isReadyYT, 50);
        }
      },
      createVideo() {
        if (this.work.video.type === 'vimeo') {
          const videoID = this.work.video.id;
          this.player = new Vimeo.Player(this.iframeID, {
            id: videoID
          });
        } else {
          //const videoID = this.work.video.src.replace('https://www.youtube.com/embed/', '');
          const videoID = this.work.video.id;
          this.player = new YT.Player(this.iframeID, {
            height: this.work.video.height,
            width: this.work.video.width,
            videoId: videoID,
            playerVars: {
              'enablejsapi': 1,
              'rel': 0,
            },
            events: {
              'onReady': this.onReadyYT,
              'onStateChange': this.onStateChangeYT,
            }
          });
        }
      },
      onReadyYT(e) {
        console.log('onReady', e, YT.PlayerState);
      },
      onStateChangeYT(e) {
        console.log('onStateChange', e);
      },
      firstVideo() {
        if (!this.$store.getters.isShowModal) return;
        if (this.isPlayed) return;
        this.isPlayed = true;

        if (this.work.video.type === 'vimeo') {
          this.player.play();
        } else {
          this.player.playVideo();
        }
      },
      close() {
        this.$store.commit('setShowModal', false);

        this.$router.push('/');
      },
      resize() {
        this.moveW = this.getMoveW();

        // 画像のマージン
        let margin;
        if (this.$store.getters.isPc) {
          margin = this.setting.margin.pc;
        } else {
          margin = this.setting.margin.sp;

          const bottom = (window.innerHeight - this.$refs['p-works__wrapInner'].clientHeight) / 4;
          this.styleSpUI = `bottom: ${bottom}px;`;
        }

        if (this.work.type === 'video') {
          //動画をブラウザサイズにフィットさせる

          // ヘッダとフッタの高さ
          const height = this.$refs['wrap-head'].clientHeight + this.$refs['wrap-foot'].clientHeight;

          // 動画のリサイズ
          const defW = window.innerWidth;
          const defH = window.innerHeight;
          const winW = defW;
          const winH = defH - height;

          //var scale = Math.max(160 / windowW, 90 / windowH)
          const scale = Math.max(16 / winW, 9 / winH);
          const iframeW = 16 / scale;
          const iframeH = 9 / scale;
          //const iframeX = (defW - iframeW) / 2;
          //const iframeY = (defH - iframeH) / 2;

          //const style = document.getElementById('c-player__iframe').style;
          //style.position = 'absolute';
          //style.left = `${iframeX}px`;
          //style.top = `${iframeY}px`;
          //style.width = `${iframeW}px`;
          //style.height = `${iframeH}px`;

          this.styleWrap = `height: ${iframeH}px; width: ${iframeW}px;`;
          this.styleWidth = '';
        } else if (this.work.type === 'video2') {
          //動画を横100%にする、動画がブラウザより高い場合にiframe上でスクロール（wheel）が効かなくなる
          const winH = window.innerHeight;
          const height = this.$refs['wrap-head'].clientHeight + this.$refs['wrap-video'].clientHeight + this.$refs['wrap-foot'].clientHeight;

          if (winH > height) {
            this.isCenter = true;
          } else {
            this.isCenter = false;
          }
          this.styleWidth = '';
        } else {
          const rect = this.$refs['wrap-gallery-img'][0].getBoundingClientRect();
          const winW = window.innerWidth;
          const winH = window.innerHeight;
          const height = this.$refs['wrap-head'].clientHeight + rect.height + this.$refs['wrap-foot'].clientHeight;
          const width = (rect.width * this.max) + (margin * this.max);
          const startX = (winW - rect.width) * 0.5;

          this.moveW = rect.width + margin;

          this.styleWrap = `height: ${rect.height}px; width: ${winW}px;`;
          this.styleUL = `left: ${startX}px;`;
          this.styleUL_a = `left: -${width - startX}px;`;
          this.styleUL_b = `left: ${width + startX}px;`;

          for (let i = 0; i < this.max; i++) {
            this.styleList[i] = `left: ${(rect.width * i) + (margin * i)}px`;
          }

          this.styleWidth = `width: ${rect.width}px;`;

          if (winH > height) {
            this.isCenter = true;
          } else {
            this.isCenter = false;
          }

          if (this.max > 1) {
            // スライドの位置を調整
            gsap.set(this.$refs['wrap-gallery-ul'], {
              x: -this.moveW * this.counter,
            });

            gsap.set(this.$refs['wrap-gallery-ul_a'], {
              x: -this.moveW * this.counter,
            });

            gsap.set(this.$refs['wrap-gallery-ul_b'], {
              x: -this.moveW * this.counter,
            });
          }
        }
      },
      moveSlide(direction) {
        if (!this.$store.getters.isShowModal) return false;

        let next = null;
        if (direction === 'left') {
          //left
          next = this.counter + 1;
        } else {
          //right
          next = this.counter - 1;
          if (next < 0) {
            this.counter = this.max;
            next = this.counter - 1;
          }
        }

        gsap.fromTo(this.$refs['wrap-gallery-ul'], {
          x: -this.moveW * this.counter,
        }, {
          duration: 0.5,
          x: -this.moveW * next,
        });

        gsap.fromTo(this.$refs['wrap-gallery-ul_a'], {
          x: -this.moveW * this.counter,
        }, {
          duration: 0.5,
          x: -this.moveW * next,
        });

        gsap.fromTo(this.$refs['wrap-gallery-ul_b'], {
          x: -this.moveW * this.counter,
        }, {
          duration: 0.5,
          x: -this.moveW * next,
          onComplete: this.slideMoveComp,
        });

        let prev = this.counter + 1;
        if (prev > this.max) {
          prev = 1;
        }

        if (next === this.max) {
          this.counter = 0;
        } else {
          this.counter = next;
        }

        this.$refs['wrap-gallery'].classList.remove(`is-current${prev}`);
        this.$refs['wrap-gallery'].classList.add(`is-current${this.counter + 1}`);
      },
      swipeMouse(e) {
        if (!this.$store.getters.isShowModal) return false;
        if (this.max < 2 || this.isSliding) return e.preventDefault();

        if (e.type === 'mousedown') {
          // タッチ開始
          this.isMouseDown = true;
          this.touchStartX = e.clientX;
          this.startTime = Date.now();

        } else if (e.type === 'mousemove') {
          if (this.isMouseDown) {
            // タッチの動きに追従
            this.touchMoveX = e.clientX - this.touchStartX;
            const slideX = (-this.moveW * this.counter) + this.touchMoveX;

            // スライドの位置を調整
            gsap.set(this.$refs['wrap-gallery-ul'], {
              x: slideX,
            });

            gsap.set(this.$refs['wrap-gallery-ul_a'], {
              x: slideX,
            });

            gsap.set(this.$refs['wrap-gallery-ul_b'], {
              x: slideX,
            });
          }
        } else if (e.type === 'mouseup') {

          this.isMouseDown = false;

          // タッチ完了で状態を判定
          this.touchMoveX = e.clientX - this.touchStartX;
          if (Math.abs(this.touchMoveX) > 10 && Date.now() - this.startTime <= 200) {
            // スライドする
            this.swipeMove(this.touchMoveX < 0);
          } else if (Math.abs(this.touchMoveX) > (this.moveW * 0.2)) {
            // スライドする
            this.swipeMove(this.touchMoveX < 0);
          } else {
            // 元に戻す
            this.swipeNone();
          }

        } else {
          // 元に戻す
          this.swipeNone();
        }
      },
      swipe(e) {
        if (!this.$store.getters.isShowModal) return false;
        if (this.max < 2 || this.isSliding) return e.preventDefault();

        if (e.type === 'touchstart') {
          // タッチ開始
          this.touchStartX = e.touches[0].pageX;
          this.startTime = Date.now();
        } else if (e.type === 'touchmove') {
          // タッチの動きに追従
          this.touchMoveX = e.changedTouches[0].pageX - this.touchStartX;
          const slideX = (-this.moveW * this.counter) + this.touchMoveX;

          // スライドの位置を調整
          gsap.set(this.$refs['wrap-gallery-ul'], {
            x: slideX,
          });

          gsap.set(this.$refs['wrap-gallery-ul_a'], {
            x: slideX,
          });

          gsap.set(this.$refs['wrap-gallery-ul_b'], {
            x: slideX,
          });
        } else if (e.type === 'touchend') {
          // タッチ完了で状態を判定
          this.touchMoveX = e.changedTouches[0].pageX - this.touchStartX;
          if (Math.abs(this.touchMoveX) > 10 && Date.now() - this.startTime <= 200) {
            // スライドする
            this.swipeMove(this.touchMoveX < 0);
          } else if (Math.abs(this.touchMoveX) > (this.moveW / 2.5)) {
            // スライドする
            this.swipeMove(this.touchMoveX < 0);
          } else {
            // 元に戻す
            this.swipeNone();
          }

        } else {
          // 元に戻す
          this.swipeNone();
        }
      },
      swipeMove(direction) {
        this.isSliding = true;

        let next = null;
        if (direction) {
          //left
          next = this.counter + 1;
        } else {
          //right
          next = this.counter - 1;
          if (next < 0) {
            this.counter = this.max;
            next = this.counter - 1;
          }
        }

        // スライドが範囲外の場合、元に戻す
        if (this.isCurrent > this.max) {
          this.isCurrent = this.max;
          return this.swipeNone();
        } else if (this.isCurrent < 1) {
          this.isCurrent = 1;
          return this.swipeNone();
        }

        gsap.to(this.$refs['wrap-gallery-ul'], {
          duration: 0.5,
          x: -this.moveW * next,
        });

        gsap.to(this.$refs['wrap-gallery-ul_a'], {
          duration: 0.5,
          x: -this.moveW * next,
        });

        gsap.to(this.$refs['wrap-gallery-ul_b'], {
          duration: 0.5,
          x: -this.moveW * next,
          onComplete: this.slideMoveComp,
        });

        let prev = this.counter + 1;
        if (prev > this.max) {
          prev = 1;
        }

        if (next === this.max) {
          this.counter = 0;
        } else {
          this.counter = next;
        }

        this.$refs['wrap-gallery'].classList.remove(`is-current${prev}`);
        this.$refs['wrap-gallery'].classList.add(`is-current${this.counter + 1}`);
      },
      slideMoveComp() {
        this.isSliding = false;
      },
      swipeNone() {
        // スライドの位置を元に戻す
        gsap.to(this.$refs['wrap-gallery-ul'], {
          duration: 0.4,
          x: -this.moveW * this.counter,
        });

        gsap.to(this.$refs['wrap-gallery-ul_a'], {
          duration: 0.4,
          x: -this.moveW * this.counter,
        });

        gsap.to(this.$refs['wrap-gallery-ul_b'], {
          duration: 0.4,
          x: -this.moveW * this.counter,
        });

        this.isSliding = false;
      },
      getMoveW() {
        if (!this.$store.getters.isPc) {
          return (680 / 750) * window.innerWidth;
        } else {
          return window.innerWidth * 0.5;
        }
      },
      getSlideWidth() {
        // スライド移動座標
        let posX = 0;
        //if (this.isDevice === "sp") {
        //posX = ((this.moveW * this.spRatio) / this.spBase) * window.innerWidth;
        //} else {
        posX = this.moveW;
        //}

        return posX;
      },
      resizeCallback(entries) {
        this.resize();
      },
      resizeBody(entries) {
        /*const winH1 = this.$parent.$el.clientHeight;
        const winH2 = window.innerHeight;
        if (winH1 > winH2) {
          this.$el.style.height = `${winH1}px`;
        } else {
          this.$el.style.height = `${winH2}px`;
        }*/
      },
      destroy() {
        this.ro.unobserve(this.$refs['p-works__wrap']);
        this.ro.unobserve(this.$refs['wrap-head']);
        this.ro.disconnect();
        this.ro = null;

        this.roBody.unobserve(document.body);
        this.roBody.disconnect();
        this.roBody = null;

        window.removeEventListener('resize', this.resizeBody);
        document.removeEventListener('keydown', this.onKeydown);
        //this.$store.commit('setShowModal', false);

        if (this.player) {
          this.player.destroy();
          this.player = null;
        }
        this.isPlayed = false;
        this.isSliding = false;

        this.styleWrap = '';
        this.styleUL = '';
        this.styleUL_a = '';
        this.styleUL_b = '';
        this.styleList = [];
        this.styleWidth = '';
        this.isCenter = false;
        this.id = null;
        this.work = null;
        this.params = null;
        this.to = null;
        this.from = null;
        this.touchStartX = 0;
        this.touchMoveX = 0;
        this.moveW = 0;
        this.startTime = null;
        this.elSlider = null;

        if (this.ps) {
          this.ps.destroy();
          this.ps = null;
        }
      },
    }
  }
</script>